import priorityGreenBar from '@/assets/images/priority-green-bar.svg';
import priorityOrangeBar from '@/assets/images/priority-oranage-bar.svg';
import priorityRedBar from '@/assets/images/priority-red-bar.svg';

export const PRIORITY_MAP = {
  1: { icon: priorityGreenBar, label: 'Low' },
  2: { icon: priorityOrangeBar, label: 'Medium' },
  3: { icon: priorityRedBar, label: 'High' },
};
